import "./ThreeDots.css";

function ThreeDots() {
  return <p className="ThreeDots">. . .</p>;
}

export default ThreeDots;
